<!-- @migration-task Error while migrating Svelte code: $$props is used together with named props in a way that cannot be automatically migrated. -->
<script lang="ts">
    import {
        Chart,
        type ChartConfiguration,
        type ChartTypeRegistry,
        type Tick,
        type TooltipItem,
    } from "chart.js/auto";
    import "chartjs-adapter-luxon";
    import { onMount } from "svelte";

    import LoadingSpinner from "./LoadingSpinner.svelte";
    import {
        createGradientCallback,
        getCssColor,
        MyChartType,
        timeStringToTimeUnit,
        type DataSetDescription,
    } from "../../utility/GraphHelper.svelte";
    import { parseIntervalStringToSeconds } from "../../utility/DateTimeHelper";
    
    // TODO create a true random number here
    let uniqueChartLabel: string = "" +Math.floor(Math.random()*100000);

    let myChart: Chart;

    export let chartType: MyChartType = MyChartType.LINE;
    export let hasGradient: boolean = true;
    export let stacked: boolean = false;
    export let chartLoading: boolean = true;

    export let title: string;
    export let aggregation = "10min";

    export let valueConversionFunction: (
                            tooltipItem: TooltipItem<keyof ChartTypeRegistry> | number |string, index: number, ticks: Tick[]) => string = undefined;

    export let to = new Date(Date.now());

    // export let labels: string[];
    export let seriesCfg: DataSetDescription[] = [];
    export let data: Map<Date, number>[] = undefined;

    let myChartConfig: ChartConfiguration;

    function alignGraphs(
        chartConfigs: ChartConfiguration[],
        from: Date,
        to: Date,
    ) {
        chartConfigs.forEach((val) => {
            if (val) {
                val.options.scales["x"].suggestedMax = to;
                val.options.scales["x"].suggestedMin = from;

                let timeUnitString: string = timeStringToTimeUnit(aggregation);
                val.options.scales["x"]["time"].unit = timeUnitString;
            }
        });
    }
    function updateIntervalCallback(to: Date, aggreationString: string): Date {
        let intervalInSeconds: number =
            parseIntervalStringToSeconds(aggreationString);
        let newfrom = new Date(Date.now());
        newfrom.setSeconds(to.getSeconds() - 10 * intervalInSeconds);

        return newfrom;
    }

    export let from: Date = updateIntervalCallback(to, aggregation);
    $: from = updateIntervalCallback(to, aggregation);

    export let primaryColorIdentifier = "primary";
    export let secondaryColorIdentifier = "secondary";

    let maxColor = getCssColor("--bs-green");
    let minColor = getCssColor("--bs-pink");
    let avgColor = getCssColor("--bs-gray");

    myChartConfig = {
        type: chartType == MyChartType.LINE ? "line" : "bar",
        data: {
            labels: [],
            datasets: [

            ],
        },

        options: {
            plugins: {
                legend: {
                    display: false,
                },

                tooltip: {
                    callbacks: {
                        //@ts-ignore
                        label: valueConversionFunction,
                    },
                }
            },
            responsive: true,
            scales: {
                //@ts-ignore
                x: {
                    stacked: stacked,
                    type: "time",
                    time: {
                        unit: "minute",
                    },
                    suggestedMin: from,
                    suggestedMax: to,
                },
                y: {
                    stacked: stacked,
                    beginAtZero: true,
                    ticks: {
                        // stepSize: 1,
                        callback: valueConversionFunction,
                    },
                    
                },
            },
        },
    };

    seriesCfg.forEach((desc: DataSetDescription) => {
        myChartConfig.data.datasets.push(
            {
                label: desc.label,
                fill: true,
                backgroundColor: hasGradient ? createGradientCallback(desc.colorIdentifier, desc.colorIdentifier) : getCssColor("--bs-"+desc.colorIdentifier),
                borderColor: getCssColor("--bs-"+desc.colorIdentifier),
                tension: 0.5,
                data: [],
            }
        );
    });


    let elementChart: HTMLElement;

    function updateData(d: Map<Date, number>[]) {
        if(!elementChart) {
            return;
        }
        to = new Date(Date.now());
        alignGraphs(
            [
                myChartConfig,
            ],
            from,
            to,
        );

        // Convert the Time -> Totals map to a breakdown for count, unique and duration


        // TODO merge labels //[... new Set[...array1, ...array2])]
        if(!data || data.length == 0) {
            return;
        }

        const sortedKeys = Array.from(data[0].keys()).sort((a, b) => a.getTime() - b.getTime());
        myChart.data.labels = sortedKeys;
        let i = 0;
        for(let element of data) {
            myChart.data.datasets[i++].data = Array.from(
                element.values()
            );
        }

        myChart.update();
    }


    onMount(() => {
        elementChart = document.getElementById("chart_"+uniqueChartLabel);

        myChart = new Chart(
            elementChart as HTMLCanvasElement,
            myChartConfig as ChartConfiguration,
        );

        updateData(data);

    });

    $: updateData(data);


</script>


<div class="{$$props.class}" style="{$$props.style}" >
    <!-- Card -->
    <div class="card  flex-fill w-100">
        <div class="position-absolute top-50 start-50 translate-middle">
            <LoadingSpinner
                class="float-end"
                loaded={myChart && !chartLoading}
            ></LoadingSpinner>
        </div>
        <div class="card-header  card-header-space-between">
            <!-- Title -->
            <h2 class="card-header-title h4 text-uppercase">
                {title}
            </h2>

            <!-- Label -->
             {#each seriesCfg as cfg}
                <h6 class="text-uppercase text-body-secondary fw-semibold mb-0 mx-1">
                    <span class="legend-circle-lg bg-{cfg.colorIdentifier}"></span>
                    {cfg.label}
                </h6>                
             {/each}

        </div>

        <div class="card-body d-flex flex-column">
            <!-- Chart -->
            <div class="chart-container flex-grow-1 h-275px">
                <canvas id="chart_{uniqueChartLabel}"></canvas>
            </div>
        </div>
    </div>
</div>